import React from 'react';
import { Navigate } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { userSelect } from '../redux/selectors/index';

// handle the private routes
function UnverifiedMailRoute({ children }) {
  const users = useSelector(userSelect);

  const needsVerification = ((users?.emailVerification ?? 1) == 0) || ((users?.phoneVerification ?? 1) == 0);
  
  return needsVerification ? children : <Navigate to="/signin" replace />;
}

export default UnverifiedMailRoute;